import { makeObservable, observable, flow, action, computed } from "mobx";
import { toast } from "sonner";
import { api } from "@/lib/services";
import { ApiRoutes } from "@/lib/routes";

export default class CreateLabelStore {
  visible = false;
  processing = false;

  constructor(parentStore) {
    makeObservable(this, {
      visible: observable,
      processing: observable,
      show: action,
      hide: action,
      toggle: action,
      save: flow,
      canCreate: computed,
    });

    this.parentStore = parentStore;
  }

  get canCreate() {
    return (
      this.parentStore.parentStore.authenticationStore.isAdmin ||
      this.parentStore.parentStore.authenticationStore.isAgent
    );
  }

  show() {
    this.visible = true;
  }

  hide() {
    this.visible = false;
  }

  toggle(visible) {
    this.visible = visible === true ? true : visible === false ? false : !this.visible;
  }

  *save({ modelId, name, description, isDefault }) {
    try {
      this.processing = true;
      const response = yield api.post(ApiRoutes.forModelLabels(modelId), { name, description, isDefault: !!isDefault });
      this.visible = false;
      toast.success("Label created successfully");
      return { success: true, data: response.data };
    } catch (e) {
      toast.error("Error while creating label", {
        description: e.message || "Unexpected error, please try again later.",
      });
      return { success: false, error: e };
    } finally {
      this.processing = false;
    }
  }
}
